<form [formGroup]="contactFg">
  <div *ngIf="layout != 'horizontal'">
    <div class="row">
      <div class="form-group col col-ms-6 col-xs-6">
      <div class="card-title-group">
        <h5>{{cardTitle}}</h5>
        <span *ngIf="tooltipContext"><tooltip [register]="tooltipContext.register" [tab]="tooltipContext.tab" [section]="tooltipContext.section" [field]="tooltipContext.fieldName"></tooltip></span>
      </div>        
      <label class="control-label" [ngClass]="{'required': isRequired || validate}" for="firstName">First Name</label>
        <input id="firstName" formControlName="firstName" title="First Name" type="text" maxlength="51"
               class="form-control" placeholder="First name" aria-required="true" />
        <div class="text-danger" [hidden]="contactFg.controls.firstName.valid || !contactFg.controls.firstName.touched">
          <small *ngIf="isRequired && contactFg.controls.firstName.hasError('required')">First Name is required.</small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group col col-ms-6 col-xs-6">
        <label class="control-label" [ngClass]="{'required': lastNameRequired}" for="lastName">Last Name</label>
        <input id="lastName" formControlName="lastName" title="First name" type="text" maxlength="51"
               class="form-control" placeholder="Last name" aria-required="true" />
        <div class="text-danger" [hidden]="contactFg.controls.lastName.valid || !contactFg.controls.lastName.touched">
          <small *ngIf="lastNameRequired && contactFg.controls.lastName.hasError('required')">Last Name is required.</small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group col col-ms-6 col-xs-6">
        <label class="control-label" [ngClass]="{'required': isRequired || validate}" for="email">Email</label>
        <input id="email" formControlName="email" title="Email" type="text" maxlength="100" class="form-control"
               placeholder="email" aria-required="true" />
        <div class="text-danger" [hidden]="contactFg.controls.email.valid || !contactFg.controls.email.touched">
          <small *ngIf="isRequired && contactFg.controls.email.hasError('required')">Email is required.</small>
          <small *ngIf="contactFg.controls.email.hasError('invalidEmail') || contactFg.controls.email.hasError('email')">Email is invalid.</small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group col col-ms-6 col-xs-6">
        <label class="control-label" [ngClass]="{'required': isRequired || validate}" for="phone">Phone</label><span *ngIf="validate" class="small ml-2"><strong>(Phone or mobile is required)</strong></span>
        <input id="phone" formControlName="phone" title="phone" type="text" maxlength="15"
               class="form-control" placeholder="phone" aria-required="true" />
      </div>
    </div>
    <div class="row">
      <div class="form-group col col-ms-6 col-xs-6">
        <label class="control-label" for="mobile">Mobile</label>
        <input id="mobile" formControlName="mobile" title="mobile" type="text" maxlength="15"
               class="form-control" placeholder="mobile" aria-required="true" />
      </div>
    </div>
  </div>

  <div class="col-12" *ngIf="layout == 'horizontal'">
    <div class="row"><h5>{{cardTitle}}</h5>
      <span class="p-2"  *ngIf="tooltipContext"><tooltip [register]="tooltipContext?.register" [tab]="tooltipContext?.tab" [section]="tooltipContext?.section" [field]="tooltipContext?.fieldName"></tooltip></span>
    </div>
    <div class="row">
      <div class="col-12 form-group">
        <div class="form-inline">
          <label class="control-label col-2" [ngClass]="{'required': isRequired || validate}" for="firstName">First Name</label>
          <input id="firstName" formControlName="firstName" title="First Name" type="text" maxlength="51"
                 class="form-control col-sm-6" placeholder="First name" aria-required="true" />
        </div>
        <div class="form-inline" [hidden]="contactFg.controls.firstName.valid || !contactFg.controls.firstName.touched">
          <div class="col-2"></div>
          <div class="text-danger col-sm-6">
            <small *ngIf="isRequired && contactFg.controls.firstName.hasError('required')">First Name is required.</small>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 form-group">
        <div class="form-inline">
          <label class="control-label col-2" [ngClass]="{'required': lastNameRequired}" for="lastName">Last Name</label>
          <input id="lastName" formControlName="lastName" title="First name" type="text" maxlength="51"
                 class="form-control col-sm-6" placeholder="Last name" aria-required="true" />
        </div>
        <div class="form-inline" [hidden]="contactFg.controls.lastName.valid || !contactFg.controls.lastName.touched">
          <div class="col-2"></div>
          <div class="text-danger col-sm-6">
            <small *ngIf="lastNameRequired && contactFg.controls.lastName.hasError('required')">Last Name is required.</small>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 form-group">
        <div class="form-inline">
          <label class="control-label col-2" [ngClass]="{'required': isRequired || validate}" for="email">Email</label>
          <input id="email" formControlName="email" title="Email" type="text" maxlength="100"
                 class="form-control col-sm-6" placeholder="email" aria-required="true" />
        </div>
        <div class="form-inline" [hidden]="contactFg.controls.email.valid || !contactFg.controls.email.touched">
          <div class="col-2"></div>
          <div class="text-danger col-sm-6">
            <small *ngIf="isRequired && contactFg.controls.email.hasError('required')">Email is required.</small>
            <small *ngIf="contactFg.controls.email.hasError('invalidEmail') || contactFg.controls.email.hasError('email')">Email is invalid.</small>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 form-group">
        <div class="form-inline">
          <label class="control-label col-2" [ngClass]="{'required': isRequired || validate}" for="phone">Phone</label>
          <input id="phone" formControlName="phone" title="phone" type="text" maxlength="15"
                 class="form-control col-sm-6" placeholder="phone" aria-required="true" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 form-group">
        <div class="form-inline">
          <label class="control-label col-2" for="mobile">Mobile</label>
          <input id="mobile" formControlName="mobile" title="mobile" type="text" maxlength="15"
                 class="form-control col-sm-6" placeholder="mobile" aria-required="true" />
        </div>
      </div>
    </div>
  </div>
</form>
